import { createFileRoute } from '@tanstack/react-router';

import { CourseListPage } from '@/views/admin/course-list-page.tsx';

export const Route = createFileRoute('/admin/courses')({
  component: CourseListPage,
});
